import React from 'react';
import styled from 'styled-components';

const Spacer = (props) => <SpacerElement height={props.blok.height} />;

const SpacerElement = styled.div`
  height: ${(props) => props.height}rem;
`;

export default Spacer;
